module.exports = __webpack_public_path__ + "static/img/British 31.0cad9ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/ls37-2/British 31.png
// module id = GdPI
// module chunks = 12